import ms from 'ms';
import * as z from 'zod';

const createEnv = () => {
  const EnvSchema = z.object({
    API_URL: z.string(),
    APP_URL: z.string().optional().default('http://localhost:3000'),
    APP_MOCK_API_PORT: z.string().optional().default('8080'),
    ENABLE_API_MOCKING: z
      .string()
      .refine(s => s === 'true' || s === 'false')
      .transform(s => s === 'true')
      .optional(),
    SKIP_LOGIN: z
      .string()
      .refine(s => s === 'true' || s === 'false')
      .transform(s => s === 'true')
      .optional(),
    LOGIN_TOKEN_LIFETIME: z
      .string()
      .refine(s => ms(s as ms.StringValue) !== undefined)
      .transform(s => ms(s as ms.StringValue))
      .optional(),
    WURCS2IMAGE_VERSION: z.string().optional().default('0.10.0'),
  });

  const envVars = Object.entries(import.meta.env).reduce<
    Record<string, string>
  >((acc, curr) => {
    const [key, value] = curr;
    if (key.startsWith('VITE_APP_')) {
      acc[key.replace('VITE_APP_', '')] = value;
    }
    return acc;
  }, {});

  const parsedEnv = EnvSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided.
The following variables are missing or invalid:
${Object.entries(parsedEnv.error.flatten().fieldErrors)
  .map(([k, v]) => `- ${k}: ${v}`)
  .join('\n')}
`,
    );
  }

  return parsedEnv.data;
};

export const env = createEnv();
